var en_GB = {};
module['exports'] = en_GB;
en_GB.title = "English (Great Britain)";
en_GB.address = require("./address");
en_GB.internet = require("./internet");
en_GB.phone_number = require("./phone_number");
en_GB.cell_phone = require("./cell_phone");